import ReactDOM from 'react-dom/client'
import AppContainer from "./AppContainer.jsx"

ReactDOM.createRoot(document.getElementById('root')!).render(
    <div>
        <AppContainer />
    </div>,
);
